import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FADE_IN_OUT_ANIMATION } from '../../animations';
import { TResponsiveSize } from '../../model';

@Component({
  selector: 'progress-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  template: `
    <mat-spinner [@fadeInOut] [diameter]="diameter()" [strokeWidth]="thickness()"></mat-spinner>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'progress-spinner'
  },
  animations: [FADE_IN_OUT_ANIMATION]
})
export class ProgressSpinnerComponent {
  thickness = input<number>(3);
  size = input<TResponsiveSize>('md');

  diameter = computed<number>(() => {
    switch (this.size()) {
      case 'xs': {
        return 20;
      }
      case 'sm': {
        return 28;
      }
      default: {
        return 40;
      }
    }
  });
}
